import { useTranslate } from "#src/hooks";
import { ConfigProvider, Form, Segmented } from "antd";
import { useAntTheme } from "hooks/useAntTheme";

export const MediaGenerationModeFormItem = () => {
  const t = useTranslate();
  const { theme } = useAntTheme();

  const values = ["Video", "Audio", "Podcast", "Disabled"];

  return (
    <ConfigProvider
      theme={{
        components: {
          Segmented: {
            itemSelectedBg: theme.colorPrimary,
            itemSelectedColor: theme.colorBgContainer,
          },
        },
      }}
    >
      <Form.Item
        label={t("pages.playbooks.sections.advanced.mediaGenerationMode.label")}
        name="media_generation_mode"
      >
        {/* value/onChange are injected automatically by the parent Form.Item */}
        <Segmented
          block
          options={values.map((value) => ({
            label: t(
              `pages.playbooks.sections.advanced.mediaGenerationMode.options.${value.toLowerCase()}`
            ),
            value,
          }))}
        />
      </Form.Item>
    </ConfigProvider>
  );
};
